import type { ReactNode } from 'react'

import { LINKS } from '~/const/external-links'

interface Props {
  icon: string
  onClick: VoidFunction
  target: string
}

const ExternalLinkItem = ({ icon, onClick, target }: Props): ReactNode => {
  const isIcon = !!LINKS[icon.toLowerCase()]

  return isIcon ? (
    <img className="external-link__icon" onClick={onClick} src={LINKS[icon.toLowerCase()]} />
  ) : (
    <div className="external-link__no-icon" onClick={onClick}>
      {target}
    </div>
  )
}

export default ExternalLinkItem
